import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
 Rocket, 
 CheckCircle, 
 ArrowRight, 
 Zap, 
 Shield, 
 HeadphonesIcon,
 Sparkles,
 Star
} from 'lucide-react';

const CTASection = () => {
 const { t } = useTranslation();

 const guarantees = [
 {
 icon: <Zap className="w-5 h-5" />,
 textKey: 'ctaSection.guarantees.instantAccess'
 },
 {
 icon: <Shield className="w-5 h-5" />,
 textKey: 'ctaSection.guarantees.moneyBack'
 },
 {
 icon: <HeadphonesIcon className="w-5 h-5" />,
 textKey: 'ctaSection.guarantees.support'
 }
 ];

 const handleBrowsePackages = () => {
 // 滚动到产品展示区域
 const productsSection = document.getElementById('products-section');
 if (productsSection) {
 productsSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
 }
 };

 return (
 <section className="py-16 lg:py-24 bg-gradient-to-br from-accent-500 via-accent-500 to-accent-600 relative overflow-hidden">
 {/* 装饰性背景元素 */}
 <div className="absolute inset-0">
 <div className="absolute top-10 left-10 w-32 h-32 bg-white/10 rounded-full blur-3xl"></div>
 <div className="absolute top-20 right-20 w-40 h-40 bg-accent-300/20 rounded-full blur-3xl"></div>
 <div className="absolute bottom-10 left-1/3 w-28 h-28 bg-accent-300/20 rounded-full blur-3xl"></div>
 <div className="absolute bottom-20 right-10 w-36 h-36 bg-accent-300/20 rounded-full blur-3xl"></div>
 </div>

 {/* 动态星星装饰 */}
 <div className="absolute inset-0 overflow-hidden">
 <Star className="absolute top-16 left-1/4 w-4 h-4 text-accent-300/60 animate-pulse" />
 <Star className="absolute top-32 right-1/3 w-3 h-3 text-white/40 animate-pulse delay-300" />
 <Star className="absolute bottom-24 left-1/2 w-5 h-5 text-accent-300/50 animate-pulse delay-700" />
 <Sparkles className="absolute top-1/2 right-1/4 w-6 h-6 text-accent-200/60 animate-pulse delay-500" />
 </div>

 <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
 <div className="text-center">
 {/* 主标题 */}
 <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
 {t('ctaSection.title')}
 </h2>
 
 {/* 副标题 */}
 <p className="text-xl md:text-2xl text-white/90 mb-10 max-w-4xl mx-auto leading-relaxed">
 {t('ctaSection.subtitle')}
 </p>

 {/* 主CTA按钮 */}
 <div className="mb-10">
 <button 
 onClick={handleBrowsePackages}
 className="group inline-flex items-center gap-3 bg-white text-accent-600 px-8 py-4 rounded-2xl font-bold text-xl shadow-md transition-all duration-300 relative overflow-hidden"
 >
 {/* 按钮背景动效 */}
 <div className="absolute inset-0 bg-gradient-to-r from-cream-50 to-white opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl"></div>
 
 {/* 按钮内容 */}
 <div className="relative z-10 flex items-center gap-3">
 <Rocket className="w-6 h-6 group-hover:rotate-12 transition-transform duration-300" />
 <span>{t('ctaSection.browseButton')}</span>
 <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform duration-300" />
 </div>
 
 {/* 闪光效果 */}
 <div className="absolute -inset-1 bg-gradient-to-r from-white via-cream-100 to-white opacity-20 blur-lg group-hover:opacity-40 transition-opacity duration-300 rounded-2xl"></div>
 </button>
 </div>

 {/* 保障项目 */}
 <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-8">
 {guarantees.map((guarantee, index) => (
 <div key={index} className="flex items-center gap-3 text-white/95">
 <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
 <CheckCircle className="w-4 h-4 text-green-300" />
 </div>
 <div className="flex items-center gap-2">
 {guarantee.icon}
 <span className="font-semibold">{t(guarantee.textKey)}</span>
 </div>
 </div>
 ))}
 </div>

 {/* 底部小字提示 */}
 <div className="mt-8 text-white/70 text-sm">
 {t('ctaSection.disclaimer')}
 </div>
 </div>
 </div>
 </section>
 );
};

export default CTASection;